// Field lists passed to every select call.

export const ORDER_FIELDS = [
  'Name',
  'customer_c',
  'full_name_c',
  'email_c',
  'plan_c',
  'term_c',
  'connections_c',
  'price_c',
  'discount_code_c',
  'discount_c',
  'currency_c',
  'payment_method_c',
  'device_c',
  'contact_method_c',
  'contact_handle_c',
  'notes_c',
  'adult_content_c',
  'wants_trial_c',
  'status_c',
  'activated_at_c',
  'ends_at_c',
  'renew_requested_at_c',
  'expiry_emailed_at_c',
  'winback_emailed_at_c',
  'line_server_c',
  'line_username_c',
  'line_password_c',
  'include_epg_c',
  'line_note_c',
  'credentials_sent_at_c',
  'telly_addon_c',
  'telly_qty_c',
  'telly_key_c',
  'telly_sent_at_c',
  'refund_accepted_at_c',
  'product_c',
  'email_verified_c',
  'discount_counted_c',
  'referral_counted_c',
  'referred_by_c',
  'gift_months_c',
  'line_verified_at_c',
  'line_verified_plan_c',
  'CreatedOn',
];

export const ORDER_LIST_FIELDS = [
  'Name',
  'customer_c',
  'full_name_c',
  'email_c',
  'plan_c',
  'term_c',
  'connections_c',
  'price_c',
  'discount_c',
  'payment_method_c',
  'status_c',
  'activated_at_c',
  'ends_at_c',
  'renew_requested_at_c',
  'telly_addon_c',
  'telly_qty_c',
  'wants_trial_c',
  'product_c',
  'email_verified_c',
  'gift_months_c',
  'line_verified_at_c',
  'line_verified_plan_c',
  'CreatedOn',
];

export const CUSTOMER_FIELDS = [
  'Name',
  'email_c',
  'contact_method_c',
  'contact_handle_c',
  'referral_code_c',
  'referrals_earned_c',
  'marketing_opt_in_c',
  'expiry_reminders_c',
  'unsubscribed_at_c',
  'tags_c',
  'notes_c',
  'email_verified_c',
  'email_verified_at_c',
  'CreatedOn',
];

export const CUSTOMER_SELF_FIELDS = [
  'Name',
  'email_c',
  'contact_method_c',
  'contact_handle_c',
  'referral_code_c',
  'marketing_opt_in_c',
  'expiry_reminders_c',
  'unsubscribed_at_c',
  'email_verified_c',
  'email_verified_at_c',
  'referrals_earned_c',
  'CreatedOn',
];

export const PAYMENT_FIELDS = ['Name', 'order_c', 'plan_c', 'kind_c', 'amount_c', 'method_c', 'paid_on_c', 'CreatedOn'];

export const TICKET_FIELDS = [
  'Name',
  'order_c',
  'email_c',
  'status_c',
  'priority_c',
  'category_c',
  'last_reply_at_c',
  'CreatedOn',
];

export const MESSAGE_FIELDS = ['Name', 'ticket_c', 'author_c', 'body_c', 'CreatedOn'];

export const REVIEW_FIELDS = [
  'Name',
  'order_c',
  'display_name_c',
  'plan_c',
  'rating_c',
  'body_c',
  'hidden_c',
  'reply_c',
  'CreatedOn',
];

export const DISCOUNT_FIELDS = [
  'Name',
  'kind_c',
  'value_c',
  'plan_c',
  'max_uses_c',
  'uses_c',
  'expires_at_c',
  'active_c',
  'customer_c',
  'credit_used_c',
  'CreatedOn',
];

export const DISCOUNT_PUBLIC_FIELDS = [
  'Name',
  'kind_c',
  'value_c',
  'plan_c',
  'max_uses_c',
  'uses_c',
  'expires_at_c',
  'active_c',
];

export const CONTACT_FIELDS = ['Name', 'email_c', 'message_c', 'status_c', 'CreatedOn'];

export const BROADCAST_FIELDS = ['Name', 'kind_c', 'audience_c', 'body_c', 'recipients_c', 'sent_by_c', 'CreatedOn'];

export const ACTIVITY_FIELDS = ['Name', 'action_c', 'target_c', 'detail_c', 'CreatedOn'];

export const ANNOUNCEMENT_FIELDS = ['Name', 'tone_c', 'show_on_c', 'active_c', 'ends_at_c', 'CreatedOn'];

export const TEMPLATE_FIELDS = ['Name', 'kind_c', 'subject_c', 'body_c', 'CreatedOn'];

export const CURRENCY_FIELDS = ['Name', 'symbol_c', 'rate_c', 'active_c'];

export const PRODUCT_FIELDS = [
  'Name',
  'slug_c',
  'plan_key_c',
  'tagline_c',
  'description_c',
  'features_c',
  'image_url_c',
  'price_1m_c',
  'price_3m_c',
  'price_6m_c',
  'price_12m_c',
  'price_once_c',
  'show_on_home_c',
  'active_c',
  'sort_c',
  'ModifiedOn',
];

/** Read one bucket from an aggregate response. */
export function aggOf(res) {
  return (id) => {
    const b = res?.aggregators?.find((a) => a.id === id);
    return Number(b?.data?.count ?? b?.count ?? b?.value ?? 0) || 0;
  };
}
